const initialState = {
  data: undefined,
  errorMessage: null,
  isLoading: false,
  isFulfilled: false,
  isRejected: false,
};

export const GetUserByUsernameData = (state = initialState, action) => {
  switch (action.type) {
    case "GET_USER_BY_USERNAME_PENDING":
      return {
        ...state,
        isLoading: true,
        isRejected: false,
        isFulfilled: false,
      };
    case "GET_USER_BY_USERNAME_REJECTED":
      return {
        ...state,
        isLoading: false,
        isRejected: true,
        errorMessage: action.payload.response.data ?? null,
      };
    case "GET_USER_BY_USERNAME_FULFILLED":
      const concatData = Object.assign(action.payload.response.data, {
        avatar: action.payload.authData?.avatar,
      });
      return {
        ...state,
        isLoading: false,
        isFulfilled: true,
        data: concatData ?? undefined,
      };
    default:
      return state;
  }
};
